import { Tabs, TabsList, TabsTrigger } from "@loot-os/ui/components/tabs";

import type { BoxTabsContent } from "../../pages/boxes/content/tabs.js";

/** The design's tabs beside the title; the list scrolls sideways when a phone is too narrow. */
export function ClassicBoxTabs({ value, label, options, onValueChange }: BoxTabsContent) {
  return (
    <Tabs
      value={value}
      onValueChange={(next) => {
        const option = options.find((o) => o.value === next);
        if (option) onValueChange(option.value);
      }}
      className="min-w-0"
    >
      <div className="overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <TabsList aria-label={label}>
          {options.map((option) => (
            <TabsTrigger key={option.value} value={option.value} className="min-w-14">
              {option.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
    </Tabs>
  );
}
